export enum Colors {
  NEUTRAL = 'neutral',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  DANGER = 'red-100',
  ERROR = 'red-100',
  WARNING = 'warning',
  BLACK = 'black',
}
